import React, { useState } from 'react';
import { 
  Button, 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  ListItemText, 
  Divider, 
  Fade,
  Box,
  Typography
} from '@mui/material';
import { 
  NotificationsNone as BellOutlineIcon,
  Notifications as BellFilledIcon,
  NotificationsActive as BellActiveIcon,
  Check as CheckIcon
} from '@mui/icons-material';

const FollowAndNoticeButton = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationSetting, setNotificationSetting] = useState('none');
  
  const open = Boolean(anchorEl);
  
  const handleSubscribe = (event) => {
    if (!isSubscribed) {
      setIsSubscribed(true);
      setNotificationSetting('all');
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleNotificationChange = (setting) => {
    setNotificationSetting(setting);
    handleClose();
  };
  
  const handleUnsubscribe = () => {
    setIsSubscribed(false);
    setNotificationSetting('none');
    handleClose();
  };
  
  const getNotificationIcon = () => {
    switch (notificationSetting) {
      case 'all':
        return <BellActiveIcon fontSize="small" />;
      case 'personalized':
        return <BellFilledIcon fontSize="small" />;
      case 'none':
        return <BellOutlineIcon fontSize="small" />;
      default:
        return <BellOutlineIcon fontSize="small" />;
    }
  };
  
  return (
    <Box sx={{ position: 'relative' }}>
      {!isSubscribed ? (
        <Button
          variant="contained"
          onClick={handleSubscribe}
          sx={{
            bgcolor: 'red',
            '&:hover': {
              bgcolor: '#cc0000',
            },
            borderRadius: '2px',
            textTransform: 'none',
            transition: 'all 0.3s',
            fontWeight: 500,
            px: 2,
          }}
        >
          フォロー
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={handleSubscribe}
          endIcon={getNotificationIcon()}
          sx={{
            bgcolor: '#e5e5e5',
            color: '#606060',
            '&:hover': {
              bgcolor: '#d5d5d5',
            },
            borderRadius: '2px',
            textTransform: 'none',
            transition: 'all 0.3s',
            fontWeight: 500,
            px: 2,
          }}
        >
          登録済み
        </Button>
      )}
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        PaperProps={{
          elevation: 3,
          sx: {
            width: 200,
            borderRadius: 1,
            mt: 0.5,
          }
        }}
      >
        <MenuItem 
          onClick={() => handleNotificationChange('all')}
          sx={{ minHeight: 48 }}
        >
          <ListItemIcon>
            <BellActiveIcon fontSize="small" color="action" />
          </ListItemIcon>
          <ListItemText primary="すべての通知" primaryTypographyProps={{ fontSize: 14 }} />
          {notificationSetting === 'all' && (
            <CheckIcon fontSize="small" color="action" />
          )}
        </MenuItem>
        
        <MenuItem 
          onClick={() => handleNotificationChange('personalized')}
          sx={{ minHeight: 48 }}
        >
          <ListItemIcon>
            <BellFilledIcon fontSize="small" color="action" />
          </ListItemIcon>
          <ListItemText primary="カスタマイズ" primaryTypographyProps={{ fontSize: 14 }} />
          {notificationSetting === 'personalized' && (
            <CheckIcon fontSize="small" color="action" />
          )}
        </MenuItem>
        
        <MenuItem 
          onClick={() => handleNotificationChange('none')}
          sx={{ minHeight: 48 }}
        >
          <ListItemIcon>
            <BellOutlineIcon fontSize="small" color="action" />
          </ListItemIcon>
          <ListItemText primary="通知オフ" primaryTypographyProps={{ fontSize: 14 }} />
          {notificationSetting === 'none' && (
            <CheckIcon fontSize="small" color="action" />
          )}
        </MenuItem>
        
        <Divider />
        
        <MenuItem 
          onClick={handleUnsubscribe}
          sx={{ minHeight: 48 }}
        >
          <ListItemText 
            primary="フォローを解除" 
            primaryTypographyProps={{ 
              fontSize: 14,
              color: '#606060',
              ml: 2 
            }} 
          />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default FollowAndNoticeButton;